import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const PARTNERS_PARTNER_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/partners',
        name: '::Menu:Partners',
        parentName: '::Menu:UserManagement',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Partners',
        order:2
      },
    ]);
  };
}
